<template>
  <div>
    <i
      v-if="state === true"
      class="icongreen icon material-icons"
      :class="{ subheading: small }"
      >check_circle</i
    >
    <i
      v-else-if="state === false"
      class="iconred icon material-icons"
      :class="{ subheading: small }"
      >cancel</i
    >
    <span v-else>-</span>
  </div>
</template>

<script>
export default {
  name: 'ButtonState',
  props: {
    state: {
      type: Boolean,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.icongreen {
  color: #4caf50;
  background-color: transparent;
}

.iconred {
  color: red;
  background-color: transparent;
}
</style>
